<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div
          class="card-header pb-0 col-sm-12 d-flex mainDiv certiDiv hospital-div-wrap"
        >
          <div class="col-sm-12 col-xs-12">
            <div class="col-sm-12 col-xs-12 titleDiv hospital-div-wrapTitle">
              <div class="col-sm-10">
                <h3>{{ $t("hospital_header_title") }}</h3>
                <h5>
                  {{ $t("hospital_header_desc1") }}<br />{{
                    $t("hospital_header_desc2")
                  }}
                </h5>
              </div>
            </div>

            <div class="card-body px-0 pt-0 pb-2">
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h3 class="sub-title">{{ $t("hospitalw_info") }}</h3>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title"
                    >{{ $t("hospitalw_cno") }}<span class="required-span"
                  /></label>
                  <div class="d-flex div905 justify-content-between">
                    <div class="position-relative col-sm-6 w-100">
                      <a-input
                        class="w-100 input-text-common"
                        v-model:value="businessNumber"
                        :maxlength="12"
                        @change="changeBusinessNumber"
                        @keyup.enter="validateBusinessNumber"
                        :placeholder="$t('hospitalw_cno_placeholder')"
                      />
                      <a-button
                        class="position-absolute black no-radius-left"
                        @click="validateBusinessNumber"
                        style="top: 0; right: 0"
                      >
                        {{ $t("hospitalw_hospitalcode_validate") }}
                      </a-button>
                      <span class="businessNumberMsg fail" />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title"
                    >{{ $t("hospitalw_name") }}<span class="required-span"
                  /></label>
                  <div class="div905">
                    <a-input
                      class="w-100 input-text-common"
                      v-model:value="hospitalName"
                      :placeholder="$t('hospitalw_name_placeholder')"
                    />
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title">{{ $t("hospitalw_ceo") }}</label>
                  <div class="div905">
                    <a-input
                      class="w-100 input-text-common"
                      v-model:value="hospitalCeoName"
                      :placeholder="$t('hospitalw_ceo_placeholder')"
                    />
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title"
                    >{{ $t("hospitalw_medicaldept")
                    }}<span class="required-span"
                  /></label>
                  <div class="div905" style="display: flex; flex-wrap: wrap">
                    <a-checkbox-group
                      v-model:value="medicalDept"
                      style="width: 100%"
                    >
                      <a-checkbox
                        v-for="(item, i) in deptList"
                        :key="i"
                        :value="item.code"
                      >
                        {{ item.name }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title"
                    >{{ $t("hospitalw_address") }}<span class="required-span"
                  /></label>
                  <div class="d-flex flex-column div905">
                    <div
                      class="d-flex col-sm-12 justify-content-between"
                      style="margin-bottom: 10px; gap: 8px"
                    >
                      <a-select
                        class="col-sm-4 hospital"
                        v-model:value="selectedAreaFirst"
                        @change="areaSecondChange"
                        :placeholder="$t('hospital_search_level1')"
                      >
                        <a-select-option value="" selected>{{
                          $t("hospital_search_level1")
                        }}</a-select-option>
                        <a-select-option
                          v-for="item in areaFirst"
                          :value="item"
                          :key="item"
                        >
                          {{ `${item}` }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        class="col-sm-4 hospital"
                        v-model:value="selectedAreaSecond"
                        @change="areaThirdChange"
                        :placeholder="$t('hospital_search_level2')"
                      >
                        <a-select-option value="" selected>{{
                          $t("hospital_search_level2")
                        }}</a-select-option>
                        <a-select-option
                          v-for="item in areaSecond"
                          :value="item"
                          :key="item"
                        >
                          {{ `${item}` }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        class="col-sm-4 hospital"
                        v-model:value="selectedAreaThird"
                        :placeholder="$t('hospital_search_level1')"
                      >
                        <a-select-option value="" selected>{{
                          $t("hospital_search_level3")
                        }}</a-select-option>
                        <a-select-option
                          v-for="item in areaThird"
                          :value="item"
                          :key="item"
                        >
                          {{ `${item}` }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <div>
                      <a-input
                        class="input-text-common"
                        style="width: 100% !important"
                        v-model:value="addrDetail"
                        :placeholder="$t('hospitalw_detailaddress_placeholder')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title">{{ $t("hospitalw_phone") }}</label>
                  <div class="div905">
                    <a-input
                      class="w-100 input-text-common"
                      v-model:value="hospitalPhoneNumber"
                      :maxlength="13"
                      @change="changeHospitalPhoneNumber"
                      :placeholder="$t('hospitalw_phone_placeholder')"
                    />
                  </div>
                </div>

                <div class="col-sm-12 inputDiv">
                  <label class="label-title">{{
                    $t("hospitalw_cno_file")
                  }}</label>
                  <div class="d-flex div905 justify-content-between">
                    <div class="position-relative col-sm-6 w-100">
                      <a-input
                        class="w-100 input-text-common"
                        v-model:value="businessFileName"
                        readonly
                      />
                      <div class="download-delete-area d-flex">
                        <div
                          class="small-btn"
                          v-if="businessImgUrl || businessFileData"
                          @click="downloadBusinessNumImage"
                        >
                          <i class="fa-solid fa-down-to-bracket" />
                        </div>
                        <div
                          class="small-btn"
                          v-if="businessImgUrl || businessFileData"
                          @click="deleteBusinessNumFile"
                        >
                          <i class="fa-solid fa-trash-can" />
                        </div>
                      </div>
                      <a-button
                        class="position-absolute no-radius-left black"
                        style="top: 0; right: 0"
                        @click="clickBusinessFileInput"
                      >
                        {{ $t("hospitalw_cno_btn") }}
                      </a-button>
                      <input
                        type="file"
                        id="businessFileInputM"
                        accept="image/jpeg, image/png, application/pdf"
                        ref="businessFileInputM"
                        @change="changeBusinessNumImage"
                        style="
                          position: absolute;
                          width: 1px;
                          height: 1px;
                          top: 0;
                          right: 0;
                          opacity: 0;
                        "
                        value=""
                      />

                      <span style="color: #8d939a; font-size: 14px"
                        >• {{ $t("hospitalw_pagelogo_desc") }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title">{{
                    $t("hospitalw_hospitalcode")
                  }}</label>
                  <div class="d-flex div905">
                    <div class="position-relative col-sm-12">
                      <a-input
                        class="input-text-common"
                        style="width: 100% !important"
                        v-model:value="hospitalCode"
                        :placeholder="$t('hospitalw_hospitalcode_placeholder')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title">{{
                    $t("hospitalw_doctor")
                  }}</label>
                  <div class="d-flex div905 flex-wrap">
                    <div class="d-flex col-sm-8 doctor-list-input">
                      <a-button
                        v-for="(item, index) in doctors"
                        :key="index"
                        style="height: fit-content"
                      >
                        {{ item }}
                        <i
                          class="fa-solid fa-xmark"
                          @click="removeDoctor(index)"
                        />
                      </a-button>
                    </div>
                    <div class="col-sm-4 position-relative doctor-input-wrap">
                      <a-input
                        class="extra"
                        v-model:value="inputText"
                        @keyup.enter="addDoctor"
                        :placeholder="$t('hospitalw_doctor_placeholder')"
                        style="width: 100%"
                      />
                      <a-button
                        class="position-absolute black no-radius-left"
                        style="top: 0; right: 0; width: 80px !important"
                        @click="addDoctor"
                      >
                        {{ $t("hospitalw_doctor_add") }}
                      </a-button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv align-items-start fileDiv">
                  <label class="label-title">{{
                    $t("hospitalw_pagelogo")
                  }}</label>

                  <div class="file-box">
                    <!-- </div> -->
                    <img
                      :src="logoImgUrl"
                      alt="로고 이미지"
                      ref="logoPrevM"
                      id="logoPrevM"
                      :style="
                        logoImgUrl || logoFileData
                          ? 'display: block;'
                          : 'display: none;'
                      "
                      @click="downloadLogoImage()"
                    />
                    <!-- <div class="file-box" v-else> -->
                    <i
                      class="fa-solid fa-image"
                      :style="
                        logoImgUrl || logoFileData
                          ? 'display: none;'
                          : 'display: block;'
                      "
                    />
                    <span
                      :style="
                        logoImgUrl || logoFileData
                          ? 'display: none;'
                          : 'display: block;'
                      "
                      >{{ $t("companyinfo_companylogo_placeholder1") }}<br />{{
                        $t("companyinfo_companylogo_placeholder2")
                      }}</span
                    >
                    <input
                      type="file"
                      accept="image/jpeg, image/png"
                      @change="changeLogoImage()"
                      id="logoFileInputM"
                      ref="logoFileInputM"
                    />
                  </div>
                  <div class="button-box d-flex flex-column">
                    <div class="d-flex">
                      <a-button
                        class="black"
                        style="margin-right: 10px"
                        @click="clickLogoFileInput()"
                      >
                        {{ $t("companyinfo_image_btn_upload") }}
                      </a-button>
                      <a-button @click="deleteLogoImage()">
                        {{ $t("companyinfo_image_btn_delete") }}
                      </a-button>
                    </div>
                    <div>
                      <ul>
                        <li>{{ $t("companyinfo_image_size") }}</li>
                        <li>{{ $t("companyinfo_image_extension") }}</li>
                        <li>{{ $t("companyinfo_image_filesize") }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4 class="subTitle">{{ $t("hospitalw_add_manager") }}</h4>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title">{{
                    $t("hospitalw_manager_name")
                  }}</label>
                  <a-input
                    type="text"
                    style="flex: 1"
                    v-model:value="managerName"
                    class="input-text-common"
                    :placeholder="$t('hospitalw_manager_name_placeholder')"
                  />
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title">{{
                    $t("hospitalw_manager_duty")
                  }}</label>
                  <a-input
                    v-model:value="managerDuty"
                    style="flex: 1"
                    class="input-text-common"
                    :placeholder="$t('hospitalw_manager_duty_placeholder')"
                  />
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title">{{
                    $t("hospitalw_manager_phone")
                  }}</label>
                  <a-input
                    style="flex: 1"
                    v-model:value="managerPhoneNumber"
                    @change="changeManagerPhoneNumber"
                    :maxlength="13"
                    class="input-text-common"
                    :placeholder="$t('hospitalw_manager_phone_placeholder')"
                  />
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title">{{
                    $t("hospitalw_manager_id")
                  }}</label>
                  <a-input
                    v-model:value="managerId"
                    disabled
                    class="input-text-common"
                    style="flex: 1"
                  />
                </div>
              </div>
            </div>
            <div
              class="card-body px-0 pt-0 pb-2"
              v-if="visibleZeissApprovalItem"
            >
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4>{{ $t("hospitalw_authorization_manage") }}</h4>
                <div
                  class="col-sm-12 inputDiv"
                  v-for="(item, index) in approvedItems"
                  :key="index"
                >
                  <label class="label-title" style="width: 200px">{{
                    item.editedName
                  }}</label>
                  <div class="d-flex align-items-center">
                    <a-switch v-model:checked="item.isSelected" />
                    <p class="true-color" :id="`item-switch-text${index}`">
                      {{
                        item.isSelected
                          ? $i18n.t("hospitalw_message_authorized")
                          : $i18n.t("hospitalw_message_not_authorized")
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="visiblePlasmappApprovalItem"
              class="card-body px-0 pt-0 pb-2"
            >
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4>{{ $t("hospitalw_add_product") }}</h4>
                <div class="col-sm-12 inputDiv mb-0">
                  <label class="label-title"
                    >{{ $t("hospitalw_select_info")
                    }}<span class="required-span"
                  /></label>
                  <div
                    class="d-flex justify-content-between hospital-product-wrap"
                    style="flex: 1"
                  >
                    <div
                      class="position-relative col-sm-6 w-100 hospital-product-row"
                    >
                      <div class="input-wrap">
                        <a-select
                          style="width: 100%"
                          v-model:value="selectedApproveItem"
                          :placeholder="$t('hospitalw_select_placeholder')"
                        >
                          <a-select-option
                            v-for="item in approvedItems"
                            :key="item._id"
                            :value="item._id"
                          >
                            {{ item.itemName }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-sm-12 inputDiv"
                  v-for="(item, index) in productArray"
                >
                  <label class="label-title">{{
                    $t("hospitalw_write_info")
                  }}</label>
                  <div
                    class="d-flex justify-content-between hospital-product-wrap"
                    style="flex: 1"
                  >
                    <div
                      class="position-relative col-sm-6 w-100 hospital-product-row"
                    >
                      <div class="input-wrap">
                        <a-input
                          style="flex: 1"
                          v-model:value="productArray[index].value"
                          class="w-100 input-text-common"
                          :class="
                            item.status === productCodeStatus.ok
                              ? 'approved'
                              : item.status === productCodeStatus.notFound ||
                                item.status === productCodeStatus.exist
                              ? 'not-approved'
                              : ''
                          "
                          :placeholder="$t('productslist_placeholder')"
                          @focusout="validateProductCode(index)"
                        />
                        <img
                          v-if="item.status === productCodeStatus.ok"
                          src="../../assets/img/approved.svg"
                        />
                        <img
                          v-if="
                            item.status === productCodeStatus.notFound ||
                            item.status === productCodeStatus.exist
                          "
                          src="../../assets/img/not-approved.svg"
                        />
                      </div>
                      <a-button @click="removeProduct(index)" shape="circle">
                        <template #icon>
                          <i class="fa-duotone fa-minus" />
                        </template>
                      </a-button>
                    </div>
                    <div
                      class="product-message success"
                      v-if="item.status === productCodeStatus.ok"
                    >
                      {{
                        `${$t(`hospitalw_message_product_${item.status}`)} (${
                          item.name
                        })`
                      }}
                    </div>
                    <div
                      class="product-message fail"
                      v-else-if="item.status === productCodeStatus.exist"
                    >
                      {{
                        `${$t(`hospitalw_message_product_${item.status}`)} (${
                          item.name
                        })`
                      }}
                    </div>
                    <div
                      class="product-message fail"
                      v-else-if="item.status === productCodeStatus.notFound"
                    >
                      {{ $t(`hospitalw_message_product_${item.status}`) }}
                    </div>
                  </div>
                </div>
                <a-button class="add-product-btn" @click="addProductRow">
                  <i class="fa-solid fa-plus" />
                  {{ $t("hospitalw_add_product_btn") }}
                </a-button>
              </div>
            </div>

            <!-- CertiLife Connector 토큰 관리 섹션 -->
            <div class="card-body px-0 pt-0 pb-2">
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h3 class="sub-title">CertiLife Connector 토큰 관리</h3>

                <div class="col-sm-12 inputDiv">
                  <label class="label-title"
                    >하드웨어 ID<span class="required-span"
                  /></label>
                  <div class="div905">
                    <a-input
                      class="w-100 input-text-common"
                      v-model:value="emrTokenInput.hwId"
                      placeholder="클라이언트 하드웨어 ID를 입력하세요 (예: 00:1A:2B:3C:4D:5E)"
                    />
                  </div>
                </div>

                <div class="col-sm-12 inputDiv align-items-start">
                  <label class="label-title"
                    >허용 IP<span class="required-span"
                  /></label>
                  <div
                    class="d-flex align-items-center"
                    style="gap: 8px; flex-wrap: wrap"
                  >
                    <div
                      v-for="(ip, index) in emrTokenInput.allowIps"
                      :key="index"
                      class="d-flex"
                      style="gap: 4px"
                    >
                      <a-input
                        class="input-text-common"
                        v-model:value="emrTokenInput.allowIps[index]"
                        placeholder="IP 주소 입력"
                        style="width: 150px"
                      />
                      <a-button
                        v-if="emrTokenInput.allowIps.length > 1"
                        @click="removeAllowIp(index)"
                      >
                        <i class="fa-solid fa-minus" />
                      </a-button>
                    </div>
                    <a-button
                      v-if="emrTokenInput.allowIps.length < 3"
                      class="black"
                      @click="addAllowIpField"
                    >
                      <i class="fa-solid fa-plus" /> 추가
                    </a-button>
                  </div>
                </div>

                <div class="col-sm-12 inputDiv">
                  <label class="label-title"></label>
                  <div class="div905">
                    <a-button
                      type="primary"
                      @click="issueEmrToken"
                      :loading="emrTokenLoading"
                      :disabled="emrTokenLoading"
                    >
                      <i class="fa-solid fa-key" style="margin-right: 4px" />
                      {{ emrAuth.token ? "토큰 재발급" : "토큰 발급" }}
                    </a-button>
                  </div>
                </div>

                <!-- 발급된 토큰 표시 (발급 직후에만 표시) -->
                <div v-if="issuedEmrToken" class="col-sm-12 emr-token-result">
                  <div class="emr-token-result-box">
                    <div class="emr-token-warning">
                      <i class="fa-solid fa-triangle-exclamation" />
                      토큰은 이 화면을 벗어나면 다시 확인할 수 없습니다. 반드시
                      복사하여 안전한 곳에 보관하세요.
                    </div>
                    <div class="emr-token-value-wrap">
                      <label>발급된 토큰</label>
                      <div class="emr-token-value">
                        <a-input
                          class="input-text-common"
                          :value="issuedEmrToken"
                          readonly
                        />
                        <a-button class="black" @click="copyEmrToken">
                          <i class="fa-solid fa-copy" /> 복사
                        </a-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex item-btn-area">
              <a-button
                @click="$router.push('/hospital')"
                class="certi-cancel-btn"
              >
                {{ $t("common_cancel") }}
              </a-button>
              <a-button
                type="primary"
                @click="modifyHospital()"
                class="certi-submit-btn"
              >
                {{ $t("hospitalm_modify_info") }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/tokenStore';
import jsonFile from "../../assets/locations.json";
import {
  oneBtnDialog,
  decodeUtfText,
  changeBytesToMegabytes,
  confirmDialog,
  phoneNumberFormatter,
  businessNumberFormatter,
  jwtDecoder,
  deepCopy,
} from "../../utils/utils";
import { productCodeStatus, MedicalDept } from "../../utils/enums";

export default {
  name: "ModifyHospital",
  components: {},
  computed: {
    visibleZeissApprovalItem() {
      const companyId = jwtDecoder(getAccessToken());
      return companyId === process.env.VUE_APP_ZEISS_ID;
    },
    visiblePlasmappApprovalItem() {
      const companyId = jwtDecoder(getAccessToken());
      if (
        companyId &&
        (companyId === process.env.VUE_APP_PLASMAPP_ID ||
          companyId === "64bf3a11924c1a9724dd2404")
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      type: "HOSPITAL",

      hospitalId: this.$route.params.hospitalId, // 병원Id

      deptList: [], // 병원 구분
      areaFirst: [], // 시군구 대분류
      areaSecond: [], // 시군구 중분류
      areaThird: [], // 읍면동 소분류
      selectedAreaFirst: "", // 선택된 시군구 대분류
      selectedAreaSecond: "", // 선택된 시군구 중분류
      selectedAreaThird: "", // 선택된 읍면동 소분류
      addrDetail: "", // 주소 상세
      medicalDept: [], // 선택된 병원구분

      hospitalName: "", // 병원명
      hospitalCeoName: "", // 병원장명
      hospitalPhoneNumber: "", // 병원명
      hospitalCode: "", // 요양기관 코드
      doctors: [], // 재직 의사
      businessNumber: "", // 사업자번호
      originalBusinessNumber: "", // 사업자번호
      inputText: "",
      managerName: "", // 관리자 이름
      managerPhoneNumber: "", // 관리자 연락처
      managerId: "", // 관리자 아이디
      managerDuty: "", // 관리자 직급
      // oldPassword: '', // 기존 관리자 비밀번호
      // password: '', // 관리자 비밀번호
      // passwordConfirm: '', // 비밀번호 확인

      businessFileName: "", // 사업자이미지 파일명
      businessFileData: null, // 실제 사업자이미지파일 정보가 담긴 폼데이터
      businessImgUrl: "", // objectStorage 상 사업자이미지 url

      logoFileName: "", // 로고이미지 파일명
      logoFileData: null, // 실제 로고파일 정보가 담긴 폼데이터
      logoImgUrl: "", // objectStorage 상 로고이미지 url

      // 검증관련 불리언, 필수값에 따라 추가 -> 최초에 등록됐던 값은 유효한 것으로 판단
      isHospitalCodeValid: true,
      isBusinessNumberValid: true,

      hasRequested: false,

      approvedItems: [],
      selectedApproveItem: null,

      productArray: [],
      originalProductArray: [],
      productCodeStatus: productCodeStatus,

      // CertiLife Connector 토큰 관리
      emrAuth: {
        token: "",
      },
      emrTokenInput: {
        hwId: "",
        allowIps: [""],
      },
      emrTokenLoading: false,
      issuedEmrToken: "", // 발급 직후 보여줄 토큰
    };
  },
  async mounted() {
    await this.getAreaList();
    await this.getDeptList();
    await this.getApprovedItems();
    await this.getHospitalInfo();
  },

  methods: {
    changeBytesToMegabytes,
    phoneNumberFormatter,
    businessNumberFormatter,
    changeHospitalPhoneNumber() {
      this.hospitalPhoneNumber = phoneNumberFormatter(
        this.hospitalPhoneNumber.toString()
      );
    },
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatter(
        this.managerPhoneNumber.toString()
      );
    },
    changeBusinessNumber(e) {
      this.businessNumber = businessNumberFormatter(this.businessNumber);
      console.log("this.businessNumber", this.businessNumber);
      this.isBusinessNumberValid = false;
      if (document.querySelector(".businessNumberMsg"))
        document.querySelector(".businessNumberMsg").innerHTML = "";
    },
    async getHospitalInfo() {
      try {
        const response = await this.$apiInstance.get(
          `/companies/${this.hospitalId}`
        );
        if (response.status === 200 || response.status === 201) {
          const { data } = response;
          if (data.addrOne) this.selectedAreaFirst = data.addrOne;
          this.areaSecondChange();
          if (data.addrTwo) this.selectedAreaSecond = data.addrTwo;
          this.areaThirdChange();
          if (data.addrThree) this.selectedAreaThird = data.addrThree;
          if (data.addrDetail) this.addrDetail = data.addrDetail;

          if (data.cNo) this.businessNumber = data.cNo;
          if (data.cNo) this.originalBusinessNumber = data.cNo;
          this.changeBusinessNumber();
          this.isBusinessNumberValid = true;

          if (data.cNoUrl) {
            this.businessImgUrl = data.cNoUrl;
            const businessUrlArray = data.cNoUrl.split("/");
            this.businessFileName = decodeUtfText(
              businessUrlArray[businessUrlArray.length - 1]
            );
          }

          if (data.call) this.hospitalPhoneNumber = data.call;
          this.changeHospitalPhoneNumber();
          if (data.ceo) this.hospitalCeoName = data.ceo;
          if (data.doctors && data.doctors.length > 0)
            this.doctors = data.doctors;
          if (data.hospitalCode) this.hospitalCode = data.hospitalCode;
          if (data.imgUrl) {
            this.logoImgUrl = data.imgUrl;
            const logoUrlArray = data.imgUrl.split("/");
            this.logoFileName = decodeUtfText(
              logoUrlArray[logoUrlArray.length - 1]
            );
          }
          const approvalItemIds = [];
          if (data.itemHospitals && this.visibleZeissApprovalItem) {
            for (let i = 0; i < this.approvedItems.length; i++) {
              const item = this.approvedItems[i];
              const hasItem = data.itemHospitals.some(
                (data) => data.itemId === item._id
              );
              if (hasItem) {
                item.isSelected = true;
              }
            }
          }
          if (this.visiblePlasmappApprovalItem) {
            if (
              data.itemHospitals &&
              Array.isArray(data.itemHospitals) &&
              data.itemHospitals.length > 0
            ) {
              this.selectedApproveItem = data.itemHospitals[0].itemId;
            } else {
              this.selectedApproveItem = this.approvedItems[0]._id;
            }
          }

          if (this.visiblePlasmappApprovalItem) {
            // this.selectedApproveItem = this.approvedItems.find(item => item._id === )
          }
          if (data.productHospitals)
            this.productArray = this.convertProductArray(data.productHospitals);
          if (data.productHospitals)
            this.originalProductArray = this.convertProductArray(
              data.productHospitals
            );
          if (data.hospitalId) this.hospitalId = data.hospitalId;
          if (data.medicalDept) this.medicalDept = data.medicalDept;
          if (data.name) this.hospitalName = data.name;
          if (data.accountInfo && data.accountInfo.mobile)
            this.managerPhoneNumber = data.accountInfo.mobile;
          this.changeManagerPhoneNumber();
          if (data.accountInfo && data.accountInfo.name)
            this.managerName = data.accountInfo.name;
          if (data.accountInfo && data.accountInfo.username)
            this.managerId = data.accountInfo.username;
          if (data.accountInfo && data.accountInfo.duty)
            this.managerDuty = data.accountInfo.duty;

          // CertiLife Connector 토큰 발급 여부 확인
          if (data.emrToken) {
            this.emrAuth.token = data.emrToken;
          }
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(
          this.$i18n.t("hospitalm_getinfo_err_title"),
          this.$i18n.t("hospitalm_getinfo_err_content"),
          false
        );
      }
    },
    convertProductArray(productArray) {
      const newArray = [];
      productArray.forEach((product, index) => {
        const obj = {};
        obj.id = product.productId;
        obj.status = productCodeStatus.notChecked;
        obj.value = product.productCode;
        newArray.push(obj);
      });
      return newArray;
    },
    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if (response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(
            (item) => item.code !== MedicalDept.COMMON
          );
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_get_dept_title"),
          this.$i18n.t("hospitalw_message_get_dept_content"),
          false
        );
      }
    },

    getAreaList() {
      this.areaFirst = Object.keys(jsonFile).sort((a, b) =>
        a.localeCompare(b, "ko-KR")
      );
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
    },

    // 시도 변화에 따른 시군구 값 넣기
    areaSecondChange() {
      if (this.selectedAreaFirst) {
        const secondLevelData = jsonFile[this.selectedAreaFirst];
        if (secondLevelData) {
          this.areaSecond = Object.keys(secondLevelData).sort((a, b) =>
            a.localeCompare(b, "ko-KR")
          );
          this.selectedAreaSecond = "";
          this.selectedAreaThird = "";
          this.areaThird = [];
        } else {
          this.selectedAreaSecond = "";
          this.selectedAreaThird = "";
          this.areaSecond = [];
          this.areaThird = [];
        }
      } else {
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = [];
        this.areaThird = [];
      }
    },
    // 시군구 변화에 따른 읍면동 값 넣기
    areaThirdChange() {
      if (this.selectedAreaSecond) {
        if (!jsonFile[this.selectedAreaFirst]) {
          this.selectedAreaThird = "";
          this.areaThird = [];
          return;
        }
        const thirdLevelData =
          jsonFile[this.selectedAreaFirst][this.selectedAreaSecond];
        if (thirdLevelData) {
          this.areaThird = Object.keys(thirdLevelData).sort((a, b) =>
            a.localeCompare(b, "ko-KR")
          );
          this.selectedAreaThird = "";
        } else {
          this.selectedAreaThird = "";
          this.areaThird = [];
        }
      } else {
        this.selectedAreaThird = "";
        this.areaThird = [];
      }
    },

    // 사업자번호 validate
    async validateBusinessNumber() {
      let isTryingForceAdd = false;
      this.isBusinessNumberValid = true;
      const businessNumberMsg = document.querySelector(".businessNumberMsg");
      if (!this.businessNumber) {
        businessNumberMsg.setAttribute("class", "businessNumberMsg fail");
        businessNumberMsg.innerHTML = this.$i18n.t("hospitalw_message_cno_err");
        this.isBusinessNumberValid = false;
      } else if (this.businessNumber.replaceAll("-", "").length < 10) {
        businessNumberMsg.setAttribute("class", "businessNumberMsg fail");
        businessNumberMsg.innerHTML = this.$i18n.t(
          "hospitalw_message_format_err"
        );
        this.isBusinessNumberValid = false;
      } else {
        try {
          const response = await this.$apiInstance.get(
            `/companies/duplicateCheck/cNo/${this.businessNumber.replaceAll(
              "-",
              ""
            )}`
          );
          if (
            response &&
            (response.status === 200 || response.status === 201) &&
            !response.data
          ) {
            businessNumberMsg.setAttribute(
              "class",
              "businessNumberMsg success"
            );
            businessNumberMsg.innerHTML = this.$i18n.t(
              "hospitalw_message_cno_okay"
            );
            this.isBusinessNumberValid = true;
          } else if (
            this.originalBusinessNumber.replaceAll("-", "") ===
            this.businessNumber.replaceAll("-", "")
          ) {
            businessNumberMsg.setAttribute(
              "class",
              "businessNumberMsg success"
            );
            businessNumberMsg.innerHTML = this.$i18n.t(
              "hospitalw_message_cno_okay"
            );
            this.isBusinessNumberValid = true;
          } else {
            const confirmResult = await confirmDialog(
              " ",
              this.$i18n.t("hospitalw_add_by_cno")
            );
            if (confirmResult) {
              const obj = {};
              obj.cNo = this.businessNumber;
              isTryingForceAdd = true;
              const response = await this.$apiInstance.post(
                `/companies/exist/hospital/force/add`,
                obj
              );
              if (
                response &&
                (response.status === 200 || response.status === 201) &&
                response.data
              ) {
                await oneBtnDialog(
                  this.$i18n.t("hospitalm_message_modify_done_title"),
                  this.$i18n.t("hospitalm_message_modify_done_content"),
                  false
                );
                this.$router.push("/hospital");
              }
            }
            businessNumberMsg.setAttribute("class", "businessNumberMsg fail");
            businessNumberMsg.innerHTML = this.$i18n.t(
              "hospitalw_message_cno_exist"
            );
            this.isBusinessNumberValid = false;
          }
        } catch (error) {
          console.log(error);
          if (isTryingForceAdd === true) {
            await oneBtnDialog(
              this.$i18n.t("hospitalm_message_modify_fail_title"),
              this.$i18n.t("hospitalm_message_modify_fail_content"),
              false
            );
          }
        }
      }
    },
    // 파일 형식 valitdate
    validateFile(file) {
      let result = true;
      if (
        file.type !== "image/png" &&
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg"
      ) {
        alert(this.$i18n.t("hospitalw_message_file_type"));
        result = false;
      } else if (changeBytesToMegabytes(file.size) > 100) {
        alert(this.$i18n.t("hospitalw_message_file_size"));
        result = false;
      }

      return result;
    },

    validateFileSize(file) {
      let result = true;
      if (changeBytesToMegabytes(file.size) > 100) {
        alert(this.$i18n.t("hospitalw_message_file_size"));
        result = false;
      }
      return result;
    },

    // 사업자등록증 이미지 onChange메소드
    changeBusinessNumImage() {
      const fileInput = document.getElementById("businessFileInputM");
      if (fileInput.files && fileInput.files[0]) {
        const validateFileSize = this.validateFileSize(fileInput.files[0]);
        if (validateFileSize) {
          this.businessFileName = fileInput.files[0].name;
          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.businessFileData = formData;
        }
      }
    },
    async clickBusinessFileInput() {
      let fileInput = document.getElementById("businessFileInputM");
      fileInput.click();
    },
    async clickLogoFileInput() {
      // await this.deleteLogoImage();
      let fileInput = document.getElementById("logoFileInputM");
      fileInput.click();
    },
    // 사업자등록증 파일 다운로드
    downloadBusinessNumImage() {
      const fileInput = this.$refs.businessFileInputM;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = this.businessImgUrl;
        downloadLink.download = this.businessFileName;
        downloadLink.click();
      }
    },
    // 사업자등록증 파일 삭제
    deleteBusinessNumFile() {
      this.businessFileName = "";
      this.businessFileData = null;
      this.businessImgUrl = "";
    },
    // 로고 이미지 onChange메소드 및 미리보기
    changeLogoImage() {
      const fileInput = document.getElementById("logoFileInputM");
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if (validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("logoPrevM").src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.logoFileName = fileInput.files[0].name;

          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.logoFileData = formData;
        }
      }
    },
    downloadLogoImage() {
      const fileInput = this.$refs.logoFileInputM;
      if (fileInput) {
        const file = fileInput.files[0];
        if (file) {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(file);
          downloadLink.download = file.name;
          downloadLink.click();
        } else {
          const downloadLink = document.createElement("a");
          downloadLink.target = "_blank";
          downloadLink.href = this.logoImgUrl;
          downloadLink.download = this.logoFileName;
          downloadLink.click();
        }
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = this.logoImgUrl;
        downloadLink.download = this.logoFileName;
        downloadLink.click();
      }
    },
    async getApprovedItems() {
      try {
        const response = await this.$apiInstance.get(`/items/approval/items`);
        if (response.status === 200 || response.status === 201) {
          this.approvedItems = response.data;
          // 자이스의 경우
          if (this.visibleZeissApprovalItem) {
            this.approvedItems = this.processZeissApprovedItems(response.data);
            return;
          }

          // 플라즈맵의 경우
          if (this.visiblePlasmappApprovalItem) {
            this.approvedItems = this.processPlasmappApprovedItems(
              response.data
            );
            return;
          }
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_get_item_title"),
          this.$i18n.t("hospitalw_message_get_item_content"),
          false
        );
      }
    },
    processZeissApprovedItems(array) {
      const newArray = deepCopy(array);
      for (const item of newArray) {
        item.editedName = item.itemName.replace(/\(.*?\)\s?/g, "");
        item.isSelected = false;
        item.text = this.$i18n.t("hospitalw_message_not_authorized");
      }
      return newArray;
    },
    processPlasmappApprovedItems(array) {
      const newArray = deepCopy(array);

      /*
      
      ...other logic to process
      
      */
      return newArray;
    },
    addProductRow() {
      const obj = {};
      obj.status = productCodeStatus.notChecked;
      obj.value = "";
      obj.id = "";
      obj.name = "";
      this.productArray.push(obj);
    },
    async validateProductCode(index) {
      const productCode = this.productArray[index];
      const hasValue = this.originalProductArray.some(
        (data) => data.value === productCode.value
      );
      if (hasValue) {
        productCode.status = productCodeStatus.ok;
        productCode.name = this.hospitalName;
      } else {
        try {
          if (productCode.value.length > 0) {
            const response = await this.$apiInstance.get(
              `/companies/by/${productCode.value}`
            );
            if (response.status === 200 || response.status === 201) {
              if (response.data.code === productCodeStatus.ok) {
                productCode.status = productCodeStatus.ok;
                productCode.id = response.data.productId;
                productCode.name = response.data.param;
              }
            }
          } else {
            productCode.status = productCodeStatus.notChecked;
            productCode.id = "";
            productCode.name = "";
          }
        } catch (error) {
          console.log(error);
          if (error && error.response) {
            if (error.response.status === 400) {
              productCode.status = productCodeStatus.exist;
              productCode.id = "";
              productCode.name = error.response.data.param;
            } else if (error.response.status === 404) {
              productCode.status = productCodeStatus.notFound;
              productCode.id = "";
              productCode.name = "";
            } else {
              await oneBtnDialog(
                this.$i18n.t("hospitalw_message_productcode_title"),
                this.$i18n.t("hospitalw_message_productcode_content"),
                false
              );
            }
          }
        }
      }
    },
    removeProduct(index) {
      this.productArray.splice(index, 1);
    },
    async modifyHospital() {
      if (!(await this.validateData())) return;
      if (this.hasRequested) return;
      this.hasRequested = true;
      try {
        const obj = {};

        const deptArr = new Array();
        this.medicalDept.forEach((ele) => {
          deptArr.push(ele);
        });

        const doctorArr = new Array();
        const filteredArray = this.doctors.filter((element) => element !== "");
        if (filteredArray.length > 0) {
          filteredArray.forEach((ele) => {
            doctorArr.push(ele);
          });
        }

        obj.medicalDept = deptArr;
        obj.name = this.hospitalName;
        if (this.hospitalCeoName) {
          obj.ceo = this.hospitalCeoName;
        } else {
          obj.ceo = "";
        }
        obj.cNo = this.businessNumber.replace(/-/g, "");

        // 사용자가 사진을 올리지 않았으면 objectStorage 호출하지 않고 기존 url 보냄
        if (this.businessFileData) {
          const businessImgUrl = await this.uploadImageOnObjectStorage(
            this.businessFileData
          );
          obj.cNoUrl = businessImgUrl;
        } else if (this.businessImgUrl) {
          obj.cNoUrl = this.businessImgUrl;
        } else {
          obj.cNoUrl = "";
        }

        if (this.logoFileData) {
          const logoImgUrl = await this.uploadImageOnObjectStorage(
            this.logoFileData
          );
          obj.imgUrl = logoImgUrl;
        } else {
          obj.imgUrl = this.logoImgUrl;
        }

        const approvalItemIds = [];

        if (this.visibleZeissApprovalItem) {
          for (const item of this.approvedItems) {
            if (item.isSelected) approvalItemIds.push(item._id);
          }
        } else if (this.visiblePlasmappApprovalItem) {
          approvalItemIds.push(this.selectedApproveItem);
        }

        if (approvalItemIds.length > 0) obj.approvalItemIds = approvalItemIds;

        obj.addrOne = this.selectedAreaFirst;
        obj.addrTwo = this.selectedAreaSecond;
        obj.addrThree = this.selectedAreaThird;
        obj.addrDetail = this.addrDetail || "";

        if (this.hospitalPhoneNumber) {
          obj.call = this.hospitalPhoneNumber.replace(/-/g, "");
        } else {
          obj.call = "";
        }

        if (this.hospitalCode) {
          obj.hospitalCode = this.hospitalCode;
        } else {
          obj.hospitalCode = "";
        }
        obj.type = this.type;
        obj.doctors = doctorArr;

        const accountInfo = {};
        accountInfo.username = this.managerId;
        accountInfo.role = this.type;
        accountInfo.name = this.managerName;
        if (this.managerDuty) {
          accountInfo.duty = this.managerDuty;
        } else {
          accountInfo.duty = "";
        }
        if (this.managerPhoneNumber) {
          accountInfo.mobile = this.managerPhoneNumber.replace(/-/g, "");
        } else {
          accountInfo.mobile = "";
        }

        obj.accountInfo = accountInfo;

        const approvalProductIds = [];
        if (this.productArray.length > 0) {
          for (const item of JSON.parse(JSON.stringify(this.productArray))) {
            if (item.id) approvalProductIds.push(item.id);
          }
        }
        obj.approvalProductIds = approvalProductIds;
        const response = await this.$apiInstance.put(
          `/companies/${this.hospitalId}`,
          obj
        );
        if (response.status === 200 || response.status === 201) {
          await oneBtnDialog(
            this.$i18n.t("hospitalm_message_modify_done_title"),
            this.$i18n.t("hospitalm_message_modify_done_content"),
            false
          );
          this.$router.push("/hospital");
        } else {
          await oneBtnDialog(
            this.$i18n.t("hospitalm_message_modify_fail_title"),
            this.$i18n.t("hospitalm_message_modify_fail_content"),
            false
          );
          this.hasRequested = false;
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(
          this.$i18n.t("hospitalm_message_modify_fail_title"),
          this.$i18n.t("hospitalm_message_modify_fail_content"),
          false
        );
        this.hasRequested = false;
      }
    },
    // 이미지 오브젝트스토리지에 업로드
    async uploadImageOnObjectStorage(fileData) {
      try {
        const response = await this.$apiInstance.post(
          `/object-storages`,
          fileData
        );
        if (response.status === 200 || response.status === 201) {
          return response.data.url;
        } else {
          return "";
        }
      } catch (error) {
        console.log(error);
        return "";
      }
    },

    // 업로드 전 검증
    async validateData() {
      let result = true;
      if (this.medicalDept.length === 0) {
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_medicaldept_err_title"),
          this.$i18n.t("hospitalw_message_medicaldept_err_content"),
          false
        );
        result = false;
      } else if (
        !this.selectedAreaFirst ||
        !this.selectedAreaSecond ||
        !this.selectedAreaThird
      ) {
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_region_err_title"),
          this.$i18n.t("hospitalw_message_region_err_content"),
          false
        );
        result = false;
      } else if (!this.hospitalName) {
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_name_err_title"),
          this.$i18n.t("hospitalw_message_name_err_content"),
          false
        );
        result = false;
      } else if (!this.businessNumber) {
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_cno_err_title"),
          this.$i18n.t("hospitalw_message_cno_err_content"),
          false
        );
        result = false;
      } else if (!this.isBusinessNumberValid) {
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_cno_valid_err_title"),
          this.$i18n.t("hospitalw_message_cno_valid_err_content"),
          false
        );
        result = false;
      } else if (this.businessNumber.replaceAll("-", "").length < 10) {
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_cno_format_err_title"),
          this.$i18n.t("hospitalw_message_cno_format_err_content"),
          false
        );
        result = false;
      } else if ((await this.validateProductArray()) === "invalid") {
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_product_invalid_err_title"),
          this.$i18n.t("hospitalw_message_product_invalid_err_content"),
          false
        );
        result = false;
      } else if ((await this.validateProductArray()) === "duplicate") {
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_product_duplicate_err_title"),
          this.$i18n.t("hospitalw_message_product_duplicate_err_content"),
          false
        );
        result = false;
      } else if (
        this.visiblePlasmappApprovalItem &&
        !this.selectedApproveItem
      ) {
        await oneBtnDialog(
          this.$i18n.t("hospitalw_message_product_plasmapp_noitem_title"),
          this.$i18n.t("hospitalw_message_product_plasmapp_noitem_content"),
          false
        );
        result = false;
      }
      return result;
    },
    async validateProductArray() {
      const valueSet = new Set();
      let hasDuplicate = false;

      for (let product of this.productArray) {
        // Check for duplicate values
        if (valueSet.has(product.value)) {
          hasDuplicate = true;
          break;
        }
        valueSet.add(product.value);
        // Check for invalid status
        if (
          product.value !== "" &&
          product.status !== productCodeStatus.ok &&
          product.status !== productCodeStatus.notChecked
        ) {
          return "invalid";
        }
      }
      if (hasDuplicate) {
        return "duplicate";
      }

      return "";
    },

    async redirectToInfo() {
      if (this.isUploadSucceeded) this.$router.push("/info");
    },
    deleteLogoImage() {
      this.logoFileData = "";
      this.logoFileName = null;
      this.logoImgUrl = "";
    },
    addDoctor() {
      if (this.inputText.trim() !== "") {
        this.doctors.push(this.inputText.trim());
        this.inputText = "";
      }
    },
    removeDoctor(index) {
      this.doctors.splice(index, 1);
    },
    timelineButtonMove(index) {
      const item = this.approvedItems[index];
      if (item.isSelected) {
        return "left:17px;background:#fff;  animation :pulse 0.5s; animation-duration:1s;";
      } else {
        return "left:2px;background:#fff)";
      }
    },
    timeLineButtonText(index) {
      const item = this.approvedItems[index];
      if (item.isSelected) {
        return "text-align:left;";
      } else {
        return "text-align:right;";
      }
    },

    // ========== CertiLife Connector 토큰 관리 메서드 ==========

    // 토큰 발급/재발급
    async issueEmrToken() {
      // 하드웨어 ID 필수 검증
      if (!this.emrTokenInput.hwId || !this.emrTokenInput.hwId.trim()) {
        await oneBtnDialog("입력 오류", "하드웨어 ID를 입력해주세요.", false);
        return;
      }

      // 허용 IP 필수 검증
      const validIps = this.emrTokenInput.allowIps.filter(
        (ip) => ip && ip.trim()
      );
      if (validIps.length === 0) {
        await oneBtnDialog(
          "입력 오류",
          "허용 IP를 최소 1개 이상 입력해주세요.",
          false
        );
        return;
      }

      // IP 형식 검증
      const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
      for (const ip of validIps) {
        if (!ipRegex.test(ip.trim())) {
          await oneBtnDialog(
            "입력 오류",
            `올바른 IP 주소 형식이 아닙니다: ${ip}`,
            false
          );
          return;
        }
      }

      const isReissue = !!this.emrAuth.token;
      const confirmMessage = isReissue
        ? "기존 토큰이 있습니다. 새로운 토큰을 발급하시겠습니까?\n기존 토큰은 더 이상 사용할 수 없게 됩니다."
        : "토큰을 발급하시겠습니까?";

      const confirmed = await confirmDialog(
        "토큰 발급",
        confirmMessage,
        "발급"
      );
      if (!confirmed) return;

      this.emrTokenLoading = true;
      try {
        const requestBody = {
          hwId: this.emrTokenInput.hwId.trim(),
          allowIps: validIps.map((ip) => ip.trim()),
        };

        const response = await this.$apiInstance.post(
          `/companies/emr-tunnel/${this.hospitalId}/token`,
          requestBody
        );

        if (response.status === 200 || response.status === 201) {
          // 발급 상태 업데이트
          this.emrAuth.token = response.data.emrToken;
          this.issuedEmrToken = response.data.emrToken;

          await oneBtnDialog(
            isReissue ? "토큰 재발급 완료" : "토큰 발급 완료",
            "토큰이 성공적으로 발급되었습니다. 아래에서 토큰을 확인하고 복사하세요.",
            false
          );
        }
      } catch (error) {
        console.log(error);
        let errorMessage = "토큰 발급에 실패했습니다.";
        if (error.response) {
          if (error.response.status === 403) {
            errorMessage =
              error.response.data?.message || "토큰 발급 권한이 없습니다.";
          } else if (error.response.status === 404) {
            errorMessage = "병원 정보를 찾을 수 없습니다.";
          }
        }
        await oneBtnDialog("토큰 발급 실패", errorMessage, false);
      } finally {
        this.emrTokenLoading = false;
      }
    },

    // 토큰 클립보드 복사
    async copyEmrToken() {
      if (!this.issuedEmrToken) {
        await oneBtnDialog("복사 실패", "복사할 토큰이 없습니다.", false);
        return;
      }

      try {
        await navigator.clipboard.writeText(this.issuedEmrToken);
        await oneBtnDialog(
          "복사 완료",
          "토큰이 클립보드에 복사되었습니다.",
          false
        );
      } catch (error) {
        console.log(error);
        await oneBtnDialog("복사 실패", "클립보드 복사에 실패했습니다.", false);
      }
    },

    // 토큰 표시/숨김 토글
    toggleEmrTokenVisibility() {
      this.showEmrToken = !this.showEmrToken;
    },

    // 허용 IP 필드 추가
    addAllowIpField() {
      if (this.emrTokenInput.allowIps.length >= 3) {
        oneBtnDialog(
          "입력 오류",
          "허용 IP는 최대 3개까지 추가할 수 있습니다.",
          false
        );
        return;
      }
      this.emrTokenInput.allowIps.push("");
    },

    // 허용 IP 삭제
    removeAllowIp(index) {
      this.emrTokenInput.allowIps.splice(index, 1);
    },

    // 토큰 마스킹 처리
    getMaskedToken(token) {
      if (!token) return "";
      if (token.length <= 12) return token;
      return (
        token.substring(0, 8) + "••••••••" + token.substring(token.length - 8)
      );
    },

    // 날짜 포맷팅
    formatDateTime(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleString("ko-KR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .row {
    padding: 14px 14px 36px 14px !important;
  }
  .hospital-div-wrap .div905 .black-btn {
    width: auto;
    padding: 10px 5px;
  }
  .hospital-div-wrap .button-box {
    margin-left: 0;
  }
  .certi-btn-regular {
    padding: 6.5px 9px;
  }
  .w-35 {
    width: 100% !important;
  }
  .hospital-div-wrap .black-btn {
    width: 100px !important;
    padding: 8px 12px;
  }
  .hospital-div-wrap .password-area button {
    top: 43px;
  }
  .item-btn-area {
    max-width: none;
  }
  p {
    margin-bottom: 0;
  }
}
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .w-35 {
    width: 50% !important;
  }
  p {
    margin-bottom: 0;
  }
}

/* CertiLife Connector 토큰 관리 스타일 */
.emr-token-result {
  margin-top: 16px;
}

.emr-token-result-box {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 16px;
}

.emr-token-warning {
  color: #856404;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.emr-token-warning i {
  color: #ffc107;
  font-size: 18px;
}

.emr-token-value-wrap label {
  display: block;
  font-size: 13px;
  color: #495057;
  margin-bottom: 8px;
}

.emr-token-value {
  display: flex;
  gap: 8px;
}

.emr-token-value .input-text-common {
  flex: 1;
  font-family: monospace;
  font-size: 13px;
}

.text-muted {
  color: #6c757d;
}

.text-warning {
  color: #856404;
}
</style>
